import { Agent } from 'src/interfaces/agent.interface';
import { PostCallEmailSection } from './PostCallEmailSection';
import { PostCallPromptSection } from './PostCallPromptSection';
import { PostCallSmsSection } from './PostCallSmsSection';

type PostCallProps = {
  agent: Agent;
  setAgent: (value: React.SetStateAction<Agent>) => void;
  loading: boolean;
};

export const PostCall = ({ agent, setAgent, loading }: PostCallProps) => {
  return (
    <div>
      <PostCallPromptSection
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />

      {/* Horizontal border separator */}
      <div className="flex items-center justify-center">
        <div className="w-full h-px bg-neutral-100 my-4"></div>
      </div>

      <PostCallSmsSection agent={agent} setAgent={setAgent} loading={loading} />

      {/* Horizontal border separator */}
      <div className="flex items-center justify-center">
        <div className="w-full h-px bg-neutral-100 my-4"></div>
      </div>

      <PostCallEmailSection
        agent={agent}
        setAgent={setAgent}
        loading={loading}
      />
    </div>
  );
};
